module.exports = __webpack_public_path__ + "static/spirit_of_wildfire-1840d8fae69ca2e49876dc2d94591c79.png";